import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _sliceInstanceProperty from "core-js-pure/stable/instance/slice.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { payResult } from '../services/index';
import { getBrowser } from '@/utils/ua';
import { fenToYuan, moneyFormat } from '@/utils/util';
import Error from '../components/error';
import { debugLog } from './common-model';
import { weblog } from '../weblog';
export default {
  components: {
    Error: Error
  },
  data: function data() {
    var _this$$route$query = this.$route.query,
        _this$$route$query$me = _this$$route$query.merchant_id,
        merchant_id = _this$$route$query$me === void 0 ? '' : _this$$route$query$me,
        _this$$route$query$ou = _this$$route$query.out_order_no,
        out_order_no = _this$$route$query$ou === void 0 ? '' : _this$$route$query$ou;
    return {
      merchant_id: merchant_id,
      out_order_no: out_order_no,
      resInfo: '',
      isShowError: false,
      errorData: {
        tips: '支付失败',
        errorMsg: ''
      },
      resultTip: '支付成功'
    };
  },
  computed: {
    payAmount: function payAmount() {
      if (!this.resInfo.order_amount) {
        return;
      }

      return moneyFormat(fenToYuan(this.resInfo.order_amount));
    },
    resultIcon: function resultIcon() {
      switch (this.resInfo.order_state) {
        case 'SUCCESS':
          return require('../assets/img/success.png');

        case 'PROCESSING':
          return require('../assets/img/processing.png');

        default:
          return require('../assets/img/fail.png');
      }
    }
  },
  created: function created() {
    var ua = getBrowser();
    this.$log.updateCurrentUrlPackage({
      page: 'H5_KSPAY_OUTSIDE_CONFIRM',
      params: {
        product: ua === 'alipay' ? 'ALIPAY' : 'WECHAT',
        order_id: this.out_order_no,
        version: 1
      }
    });
    this.getPayResult();
  },
  mounted: function mounted() {
    weblog.plugins.radar.fmp();
  },
  methods: {
    moneyFormat: moneyFormat,
    fenToYuan: fenToYuan,
    getPayResult: function () {
      var _getPayResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var payInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return payResult({
                  merchant_id: this.merchant_id,
                  out_order_no: this.out_order_no
                });

              case 2:
                payInfo = _context.sent;
                this.resInfo = payInfo;

                if (payInfo.result === 1) {
                  document.title = this.formatText(payInfo.page_title, 8);
                  debugLog("OrderState_".concat(payInfo.order_state));

                  if (this.resInfo.order_state === 'PROCESSING') {
                    this.resultTip = '处理中';
                  } else if (this.resInfo.order_state === 'SUCCESS') {
                    this.$log.sendImmediately('CLICK', {
                      action: 'PAYMENT_RESULT',
                      params: {
                        status: 'SUCCESS'
                      }
                    });
                  }
                } else {
                  debugLog("Fail_".concat(payInfo.result));
                  document.title = '支付结果';
                  this.isShowError = true;
                  this.errorData.errorMsg = payInfo.error_msg;
                  this.$log.sendImmediately('CLICK', {
                    action: 'PAYMENT_RESULT',
                    params: {
                      status: 'FAIL',
                      code: payInfo.error_msg
                    }
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPayResult() {
        return _getPayResult.apply(this, arguments);
      }

      return getPayResult;
    }(),
    formatText: function formatText(str, length) {
      return str.length > length ? _sliceInstanceProperty(str).call(str, 0, length) + '...' : str;
    }
  }
};